<template>
<div>
  <div class="signin" v-show="isShowSignin">
  <!-- <div class="signin"> -->
    <div class="signin-top"></div>
    <div class="list-group">
    <div  class="signin-li"><div class="padding-15"><input class="font-14 block width-full" type="number" placeholder="手机号码" v-model="phone_num" maxlength="11"></div></div>
        <div class="verifycode clearfix signin-li">
            <div class="padding-15"><input class="font-14 block width-full" type="number" placeholder="输入验证码" v-model="check_code" maxlength="6"></div>
          <div class="pull-right" style="margin-top:-50px;"><a class="button button-primary" @click.prevent.stop="getCheckCode">{{code_sec_msg}}</a></div>
        </div>
      <div class="btn-wrap" style="margin:30px 20px">
        <a class="button button-block button-primary button-large font-18" style="border-radius:50px;" @click.prevent.stop="login()">登录</a>
      </div>
    </div>
  </div>

  <div class="maskdiv" v-bind:class="{'hide': isHideSelectCurche}">
  <div class="popover">
    <div class="pop-wrap">
      <div>
        <span class="block text-center font-16 margin-15">请选择园点及角色</span>
        <div>
          <ul>
            <li  v-for="(item, index) in curcheList" @click="goIndex(index)">
              <div class="liner"></div>
              <a class="block clearfix " href="javascript:;" style="padding:10px 0">
                <span class="col-xs-8" style="overflow:hidden;">{{item.curcheName}}</span>
                <span class="col-xs-4">{{item.jobName}}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  </div>
</div>
</template>

<script>
import { Toast } from 'mint-ui'
import { service } from '../service'
import { mapMutations } from 'vuex'

export default {
  data () {
    return {
      msg: '登录',
      code: '',
      phone_num: '',
      check_code: '',
      check_code_para: service.setPara('getCheckCode'),
      login_para: service.setPara('loginOrYzm'),
      auto_login_para: service.setPara('autoLogin'),
      get_code_sec: 120,
      code_sec_msg: '获取验证码',
      int_code_interval: 0,
      curcheList: [],
      login_data: {},
      isHideSelectCurche: true,
      isShowSignin: false
    }
  },
  mounted: function () {
    this.phone_num = ''
    this.check_code = ''
    // var onOpenNotification = function (event) {
    //   var alertContent
    //   if (window.device.platform == 'Android') {
    //     alertContent = event.alert
    //   } else {
    //     alertContent = event.aps.alert
    //   }
    //   console.log('open Notificaiton:' + alertContent)
    // }
    // document.addEventListener('jpush.openNotification', onOpenNotification, false)

    $('.signin').css('height', $(window).height() + 'px')
    // console.log('来sign了')
    // this.$router.replace('/index')
    try {
      this.autoLogin()
    } catch (e) {
      console.log('router.beforeEach：强转错误' + e)
      window.localStorage.clear()
    }
    // var that = this
    {
      let b = window.browser()
      if (b.android) {
        document.addEventListener('backbutton', window.exitApp, false)
      } else if (b.iPhone || b.iPad) {
        try {
          window.cordova.exec(null, null, 'FinshLoadPage', 'finsihLoadPage', [])
        } catch (e) {
        }
      }
    }
  },
  created () {
    this.$store.dispatch('clearVuex')
    // this.initVuex()
  },
  methods: {
    ...mapMutations([
      'clearVuex'
    ]),
    // 获取验证码
    getCheckCode: function () {
      var reg = /^1\d{10}$/
      this.phone_num = $.trim(this.phone_num)
      if (this.get_code_sec !== 120) {
        return
      }
      if (this.phone_num === '') {
        Toast('请输入手机号')
        return
      }
      if (!reg.exec(this.phone_num)) {
        Toast('请输入正确的手机号')
        return
      }
      this.check_code_para.phone_num = this.phone_num
      let obj = {context: this, para: this.check_code_para, successFun: (response) => {
        Toast('验证码已发送')
        this.int_code_interval = setInterval(this.setIntervalCode, 1000)
      }}
      service.request(obj)
    },
    // 倒计时
    setIntervalCode: function () {
      this.get_code_sec -= 1
      if (this.get_code_sec < 0) {
        this.get_code_sec = 120
        window.clearInterval(this.int_code_interval)
        this.code_sec_msg = '获取验证码'
      } else {
        this.code_sec_msg = '获取验证码' + this.get_code_sec + ''
      }
    },
    // 登录
    login: function () {
      var reg = /^1\d{10}$/
      var regCode = /^\d{6}$/
      this.phone_num = $.trim(this.phone_num)
      this.check_code = $.trim(this.check_code)
      if (this.phone_num === '') {
        Toast('请输入手机号')
        return
      }
      if (!reg.exec(this.phone_num)) {
        Toast('请输入正确的手机号')
        return
      }
      if (this.check_code === '') {
        Toast('请输入验证码')
        return
      }
      if (!regCode.exec(this.check_code)) {
        Toast('请输入6位数字的验证码')
        return
      }

      this.login_para.phone_num = this.phone_num
      this.login_para.check_code = this.check_code

      let that = this
      let obj = {context: that, para: that.login_para, successFun: (response) => {
        window.localStorage.clear()
        that.login_data = response.data
        if (typeof that.login_data.data === 'string') {
          that.login_data.data = JSON.parse(that.login_data.data)
        }
        if (that.login_data.data.length <= 1) {
          that.goIndex(0)
        } else {
          that.curcheList = that.login_data.data
          that.isHideSelectCurche = false
        }
      }}
      service.request(obj)
    },
    // 自动登录
    autoLogin: function () {
      // var loginDataTemp = $.cookie('login_data')
      var loginDataTemp = window.localStorage['basic_login_data']
      if (loginDataTemp) {
        var loginData = JSON.parse(loginDataTemp)
        if (loginData.teacherToken && loginData.phoneNum) {
          this.auto_login_para.phoneNum = loginData.phoneNum
          this.auto_login_para.curcheId = loginData.curcheId
          this.auto_login_para.teacherToken = loginData.teacherToken

          this.check_code_para.phone_num = this.phone_num

          let that = this
          let obj = {context: that, para: that.auto_login_para, successFun: (response) => {
            if (response.data) {
              window.localStorage['login_data'] = JSON.stringify(response.data.data)
              loginData.teacherToken = response.data.teacherToken
              window.localStorage['basic_login_data'] = JSON.stringify(loginData)
            }
            this.$router.replace('/index')
          }, not100CodeFun: () => {
            that.isShowSignin = true
          }, errorFun: () => {

          }}
          service.request(obj)
        } else {
          this.isShowSignin = true
        }
      } else {
        this.isShowSignin = true
      }
    },
    goIndex: function (index) {
      var LoginData = {}
      LoginData.phoneNum = this.phone_num
      LoginData.teacherToken = this.login_data.teacherToken
      LoginData.index = index
      if (typeof this.login_data.data === 'string') {
        console.log(4)
        this.login_data.data = JSON.parse(this.login_data.data)
      }
      if (this.login_data.data.length > 0) {
        LoginData.curcheId = this.login_data.data[index].curcheId
        LoginData.teacherId = this.login_data.data[index].teacherId
        LoginData.jobId = this.login_data.data[index].jobId
        LoginData.teacherIcon = this.login_data.data[index].teacherIcon
        LoginData.baseAcessPath = this.login_data.data[index].baseAcessPath
        LoginData.serviceSchool = this.login_data.data[index].serviceSchool
      } else {
        LoginData.curcheId = 0
        LoginData.teacherId = this.login_data.teacherId
        LoginData.jobId = 10
        LoginData.teacherIcon = this.login_data.teacherIcon
        LoginData.baseAcessPath = this.login_data.baseAcessPath
        LoginData.serviceSchool = ''
      }

      // $.cookie('login_data', JSON.stringify(LoginData), { expires: 7})
      window.localStorage['basic_login_data'] = JSON.stringify(LoginData)
      window.localStorage['login_data'] = JSON.stringify(this.login_data.data)

      this.$router.replace('/index')
    }
  },
  beforeDestroy: function () {
    window.clearInterval(this.int_code_interval)
    {
      let b = window.browser()
      if (b.android) {
        document.removeEventListener('backbutton', window.exitApp, false)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Signin.vue?ad8759a8